import { createTrackerOptions } from '@/helpers/common';

const mortice = require('@/assets/lock-animations/5 lever mortice deadlock/mortice-lock-black.png');
const morticeAnimated = require('@/assets/lock-animations/5 lever mortice deadlock/mortice-lock-black.gif');

const morticeWhite = require('@/assets/lock-animations/5 lever mortice deadlock/mortice-lock-white.png');
const morticeAnimatedWhite = require('@/assets/lock-animations/5 lever mortice deadlock/mortice-lock-white.gif');

const morticeBs = require('@/assets/lock-animations/5 lever mortice deadlock conforming to BS 3621/mortice-lock-bs-black.png');
const morticeBsAnimated = require('@/assets/lock-animations/5 lever mortice deadlock conforming to BS 3621/mortice-lock-bs-black.gif');

const morticeBsWhite = require('@/assets/lock-animations/5 lever mortice deadlock conforming to BS 3621/mortice-lock-bs-white.png');
const morticeBsAnimatedWhite = require('@/assets/lock-animations/5 lever mortice deadlock conforming to BS 3621/mortice-lock-bs-white.gif');

const multipoint = require('@/assets/lock-animations/Key operated multi point lock/multipoint-black.png');
const multipointAnimated = require('@/assets/lock-animations/Key operated multi point lock/multipoint-black.gif');

const multipointWhite = require('@/assets/lock-animations/Key operated multi point lock/multipoint-white.png');
const multipointAnimatedWhite = require('@/assets/lock-animations/Key operated multi point lock/multipoint-white.gif');

const rim = require('@/assets/lock-animations/Rim automatic deadlatch with key locking handle/rim-black.png');
const rimAnimated = require('@/assets/lock-animations/Rim automatic deadlatch with key locking handle/rim-black.gif');

const rimWhite = require('@/assets/lock-animations/Rim automatic deadlatch with key locking handle/rim-white.png');
const rimAnimatedWhite = require('@/assets/lock-animations/Rim automatic deadlatch with key locking handle/rim-white.gif');

const topBottom = require('@/assets/lock-animations/Top & bottom key operated lock/top-bottom-black.png');
const topBottomAnimated = require('@/assets/lock-animations/Top & bottom key operated lock/top-bottom-black.gif');

const topBottomWhite = require('@/assets/lock-animations/Top & bottom key operated lock/top-bottom-white.png');
const topBottomAnimatedWhite = require('@/assets/lock-animations/Top & bottom key operated lock/top-bottom-white.gif');

const centralOperatedKey = require('@/assets/lock-animations/Central rail key operated lock/central-rail-black.png');
const centralOperatedKeyAnimated = require('@/assets/lock-animations/Central rail key operated lock/central-rail-black.gif');

const centralOperatedKeyWhite = require('@/assets/lock-animations/Central rail key operated lock/central-rail-white.png');
const centralOperatedKeyAnimatedWhite = require('@/assets/lock-animations/Central rail key operated lock/central-rail-white.gif');

export const INSURER_MAX_AGE = 105;
export const INSURER_MIN_AGE = 18;
export const NCD_MIN_AGE = 18;

export const COVER_ITEMS_MAX_AMOUNT = 20;
export const PROPERTY_PURCHASED_MIN_YEARS = 120;
export const CLAIMS_MAX_QTY = 5;
export const PROPERTY_BUILD_YEAR_MIN = 1000;

export const PROPERTY_ROOMS_MIN_QTY = 0;
export const PROPERTY_ROOMS_MAX_QTY = 99;

export const CONTENTS_REPLACE_COST_MIN = 5000;
export const CONTENTS_REPLACE_COST_MAX = 100000;

export const SPECIFIC_ITEM_VALUE_MIN = 1000;
export const SPECIFIC_ITEM_VALUE_MAX = 999999;

export const PROPERTY_YEARS_LIVED_MIN = 0;
export const PROPERTY_YEARS_LIVED_MAX = 255;

export const CLAIM_AMOUNT_MIN = 1;
export const CLAIM_AMOUNT_MAX = 999999;

export const NO_YES = [
  {
    value: false,
    text: 'No',
  },
  {
    value: true,
    text: 'Yes',
  },
];

// STEP 1

// property owned
export const HOME_PROPERTY_OWNED_FAVORITES = ['YM', 'YO'];
export const HOME_PROPERTY_OWNED = {
  YM: 'Yes - Mortgaged',
  RCF: 'Renting - Council, Furnished',
  RCU: 'Renting - Council, Unfurnished',
  RPF: 'Renting - Private, Furnished',
  RPU: 'Renting - Private, Unfurnished',
  HA: 'Housing Association',
  YO: 'Yes - Owned Outright',
};

// property cover type
export const COVER_PROPERTY_COVER_TYPE = {
  BC: 'Buildings and Contents',
  B: 'Buildings Only',
  C: 'Contents Only',
};
export const COVER_PROPERTY_COVER_TYPE_RENTING = 'C';
export const COVER_PROPERTY_COVER_TYPE_NOT_RENTING = 'BC';

// property sort
export const HOME_PROPERTY_SORT = {
  H: 'House',
  A: 'Flat/Apartment',
  B: 'Bungalow',
  T: 'Town House',
  O: 'Other',
};

// property type
export const HOME_PROPERTY_TYPE = {
  H: {
    D: 'Detached',
    SD: 'Semi-Detached',
    LD: 'Link Detached',
    T: 'Terrace',
    ET: 'End Terrace',
  },
  B: {
    D: 'Detached',
    SD: 'Semi-Detached',
    LD: 'Link Detached',
    T: 'Terrace',
    ET: 'End Terrace',
  },
  T: {
    D: 'Detached',
    SD: 'Semi-Detached',
    LD: 'Link Detached',
    T: 'Terrace',
    ET: 'End Terrace',
  },
  A: {
    PS: 'Purpose Built (Self-Contained)',
    CS: 'Converted (Self-Contained)',
    PO: 'Purpose Built (Other)',
    CO: 'Converted (Other)',
    MC: 'Maisonette - Converted',
    MP: 'Maisonette - Purpose Built',
  },
  O: {
    B: 'Bedsit',
    HR: 'Halls of Residence',
  },
};

// property walls made
export const HOME_PROPERTY_WALLS_MADE = {
  BR: 'Brick',
  SN: 'Stone',
  CO: 'Concrete',
  BT: 'Brick on Timber Frame',
  ST: 'Stone on Timber Frame',
  TF: 'Timber Frame',
  TP: 'Timber Frame With Plaster Panels',
  PN: 'Prefabricated - Non-Combustible',
  PC: 'Prefabricated - Combustible',
  FL: 'Flint',
  GL: 'Glass',
  CI: 'Corrugated Iron',
  AS: 'Asbestos',
  OT: 'Other',
};
export const HOME_PROPERTY_WALLS_MADE_FAVORITES = ['BR'];

// property floor
export const HOME_PROPERTY_FLOOR = {
  B: 'Basement',
  G: 'Ground Floor',
  1: '1st Floor',
  2: '2nd Floor And Above',
};

// property roof
export const HOME_PROPERTY_ROOF_MADE = {
  SL: 'Slates',
  TI: 'Tiles',
  AP: 'Asphalt',
  CO: 'Concrete',
  TH: 'Thatch',
  FT: 'Felt on Timber',
  AB: 'Asbestos',
  CI: 'Corrugated Iron',
  TM: 'Timber',
  SH: 'Shingle',
  GL: 'Glass',
  OT: 'Other',
};
export const HOME_PROPERTY_ROOF_MADE_FAVORITES = ['SL', 'TI'];

// property flat roof
export const HOME_PROPERTY_FLAT_ROOF_FAVORITES = 0;
export const HOME_PROPERTY_FLAT_ROOF = {
  0: '0%',
  1: '1% - 10%',
  11: '11% - 20%',
  21: '21% - 50%',
  50: 'Over 50%',
};

// property nearest river
export const HOME_PROPERTY_NEAREST_RIVER = {
  0: 'Within 200m',
  200: 'Between 200m and 400m Away',
  400: 'More than 400m Away',
};

// property listed
export const HOME_PROPERTY_LISTED = {
  N: 'Not Listed',
  O: 'Grade 1 Listed Building',
  T: 'Grade 2 Listed Building',
  P: 'Preservation Order',
};

// property main residence
export const HOME_PROPERTY_MAIN_RESIDENCE = {
  Y: 'Yes',
  W: 'No, it\'s a Weekend Home',
  H: 'No, it\'s a Holiday Home',
};

// STEP 2

// cover bicycle or laptop
export const COVER_PROPERTY_BICYCLE_OR_LAPTOP = {
  B: 'Bicycle',
  L: 'Laptop',
};

// cover specific items
export const COVER_PROPERTY_SPECIFIC_ITEMS = {
  AN: 'Angling Equipment',
  AQ: 'Antiques',
  AR: 'Archery Equipment',
  AG: 'Articles of Gold',
  AP: 'Articles of Precious Metals',
  AS: 'Articles of Silver',
  AE: 'Audio Equipment',
  BL: 'Binoculars',
  CO: 'Camcorders',
  CM: 'Cameras',
  CP: 'Camping Equipment',
  CL: 'Clocks',
  CT: 'Clothing',
  CC: 'Coin Collection',
  CE: 'Computer Equipment (Not Laptops)',
  CR: 'Curios',
  DE: 'DVD Equipment',
  EE: 'Electrical Equipment (Televisions, Computers, Audio, Video etc)',
  FR: 'Furs',
  GM: 'Gemstones',
  GF: 'Golfing Equipment',
  GN: 'Guns',
  HA: 'Hearing Aids',
  JL: 'Jewellery',
  ML: 'Medal Collection',
  MS: 'Mobility Scooter',
  MI: 'Musical Instruments',
  PW: 'Painting/Works of Art',
  PE: 'Photographic Equipment',
  RT: 'Rider Tack',
  SL: 'Sailsboards',
  SK: 'Skis (Including Water Skis)',
  SE: 'Sports Equipment',
  SC: 'Stamp Collection',
  TV: 'Televisions',
  VE: 'Video Equipment',
  WC: 'Watches',
  WL: 'Wheelchairs',
};

// cover all risk unspecified
export const COVER_ALL_RISKS_UNSPECIFIED_FAVORITES = 0;
export const COVER_ALL_RISKS_UNSPECIFIED = {
  0: 'None',
  1000: '£ 1,000',
  1500: '£ 1,500',
  2000: '£ 2,000',
  2500: '£ 2,500',
  3000: '£ 3,000',
  3500: '£ 3,500',
  4000: '£ 4,000',
  4500: '£ 4,500',
  5000: '£ 5,000',
  5500: '£ 5,500',
  6000: '£ 6,000',
  6500: '£ 6,500',
  7000: '£ 7,000',
  8000: '£ 8,000',
  9000: '£ 9,000',
  10000: '£ 10,000',
};

// property business type
export const HOME_PROPERTY_BUSINESS_TYPE_FAVORITE = 'NB';
export const HOME_PROPERTY_BUSINESS_TYPE = {
  NB: 'No Business or Professional Use',
  CB: 'Clerical Business Use Only',
  OB: 'Other Business Use',
  RB: 'Regular Business Visitors to Property',
};

export const LOCK_ANIMATIONS = {
  MBS: {
    black: {
      image: morticeBs,
      animation: morticeBsAnimated,
    },
    white: {
      image: morticeBsWhite,
      animation: morticeBsAnimatedWhite,
    },
  },
  M: {
    black: {
      image: mortice,
      animation: morticeAnimated,
    },
    white: {
      image: morticeWhite,
      animation: morticeAnimatedWhite,
    },
  },
  K: {
    black: {
      image: multipoint,
      animation: multipointAnimated,
    },
    white: {
      image: multipointWhite,
      animation: multipointAnimatedWhite,
    },
  },
  R: {
    black: {
      image: rim,
      animation: rimAnimated,
    },
    white: {
      image: rimWhite,
      animation: rimAnimatedWhite,
    },
  },
  TB: {
    black: {
      image: topBottom,
      animation: topBottomAnimated,
    },
    white: {
      image: topBottomWhite,
      animation: topBottomAnimatedWhite,
    },
  },
  C: {
    black: {
      image: centralOperatedKey,
      animation: centralOperatedKeyAnimated,
    },
    white: {
      image: centralOperatedKeyWhite,
      animation: centralOperatedKeyAnimatedWhite,
    },
  },
  O: {
    black: {
      image: null,
      animation: null,
    },
    white: {
      image: null,
      animation: null,
    },
  },
};

// property main door lock
export const HOME_PROPERTY_MAINDOR_LOCK = {
  MBS: {
    text: '5 Lever Mortice Deadlock Conforming to BS 3621',
    description: 'This is the same as a standard mortice deadlock but conforms to the correct British Standard. The lock will have a BS Kitemark logo or have BS3621 stamped on the lock.',
  },
  M: {
    text: '5 Lever Mortice Deadlock',
    description: 'This is the standard deadlock type. Commonly fitted to wooden doors (composite doors, aluminium doors, and uPVC doors can\'t house these door locks). The lock is fitted in the door, not mounted to the surface of the door. Typcially, the door handle does not need to be lifted to turn the key and lock the door. Usually there is only one locking point (one bolt locking the door to the door frame).',
  },
  K: {
    text: 'Key Operated Multi Point Lock',
    description: 'Used in both wooden, aluminium and uPVC doors. These will have several locking points, typically 3 or 5 bolts locking the door to the door frame. When the key is turned, all lock simultaneously. Typcially, the door handle needs to be lifted to turn the key and lock the door. These locks are most commonly found on uPVC or aluminium doors.',
  },
  R: {
    text: 'Rim Automatic Deadlatch With Key Locking Handle',
    description: 'This lock (often called a night-latch) is one that is attached to the surface of the door, and is often fitted at shoulder height. Commonly fitted to wooden doors. Usually there is only one locking point (one bolt locking the door to the door frame).',
  },
  O: {
    text: 'Other Lock Type',
    description: 'If you don\'t have any of these, choose ‘other lock type’ - and consider getting your security upgraded.',
  },
};

// property external door lock
export const HOME_PROPERTY_EXTERNALDOR_LOCK_FAVORITE = 'N';
export const HOME_PROPERTY_EXTERNALDOR_LOCK = {
  MBS: {
    text: '5 Lever Mortice Deadlock Conforming to BS 3621',
    description: 'This is the same as a standard mortice deadlock but conforms to the correct British Standard. The lock will have a BS Kitemark logo or have BS3621 stamped on the lock.',
  },
  M: {
    text: '5 Lever Mortice Deadlock',
    description: 'This is the standard deadlock type. Commonly fitted to wooden doors (composite doors, aluminium doors, and uPVC doors can\'t house these door locks). The lock is fitted in the door, not mounted to the surface of the door. Typcially, the door handle does not need to be lifted to turn the key and lock the door. Usually there is only one locking point (one bolt locking the door to the door frame).',
  },
  K: {
    text: 'Key Operated Multi Point Lock',
    description: 'Used in both wooden, aluminium and uPVC doors. These will have several locking points, typically 3 or 5 bolts locking the door to the door frame. When the key is turned, all lock simultaneously. Typcially, the door handle needs to be lifted to turn the key and lock the door. These locks are most commonly found on uPVC or aluminium doors.',
  },
  R: {
    text: 'Rim Automatic Deadlatch With Key Locking Handle',
    description: 'This lock (often called a night-latch) is one that is attached to the surface of the door, and is often fitted at shoulder height. Commonly fitted to wooden doors. Usually there is only one locking point (one bolt locking the door to the door frame).',
  },
  O: {
    text: 'Other Lock Type',
    description: 'If you don\'t have any of these, choose ‘other lock type’ - and consider getting your security upgraded.',
  },
  N: {
    text: 'No Other External Doors',
  },
};

// property patio door lock
export const HOME_PROPERTY_PATIODOR_LOCK_FAVORITE = 'N';
export const HOME_PROPERTY_PATIODOR_LOCK = {
  N: {
    text: 'No Patio Doors',
  },
  TB: {
    text: 'Top & Bottom Key Operated Lock',
    description: 'Usually key operated or surface-mounted bolts located at the top and bottom of the door and can usually only be operated from the inside.',
  },
  C: {
    text: 'Central Rail Key Operated Lock',
    description: 'Usually a type of multi-point locking system fitted to a central rail where the doors often overlap.',
  },
  K: {
    text: 'Key Operated Multi Point Lock',
    description: 'Usually have several locking points that when the key is turned, all lock simultaneously. These locks are most commonly found on uPVC doors.',
  },
  O: {
    text: 'Other Lock Type',
    description: 'If you don\'t have any of these, choose ‘other lock type’ - and consider getting your security upgraded.',
  },
};

// property occupied
export const HOME_PROPERTY_OCCUPIED = {
  P: 'Policyholder Only',
  PF: 'Policyholder and Immediate Family',
  PPF: 'Policyholder and Immediate Family and/or Partner’s Family',
  PL: 'Policyholder and Lodgers',
};

// property unoccupied
export const HOME_PROPERTY_UNOCCUPIED = {
  UD: 'Unoccupied All Day',
  UN: 'Unoccupied All Night',
  DN: 'Occupied Day and Night',
};

// property unoccupied days
export const HOME_PROPERTY_UNOCCUPIED_DAYS_FAVORITE = [0, 14];
export const HOME_PROPERTY_UNOCCUPIED_DAYS = {
  0: 'Never',
  14: '1 - 14 Days in a Row',
  30: '15 - 30 Days in a Row',
  45: '31 - 45 Days in a Row',
  60: '46 - 60 Days in a Row',
  61: '61+ Days in a Row',
};

// property total smoke alarms
export const HOME_PROPERTY_TOTAL_SMOKE_ALARMS = {
  0: 'No Smoke Alarms',
  1: '1 Smoke Alarm',
  2: '2 Smoke Alarms',
  3: '3+ Smoke Alarms',
};

// property local watch
export const HOME_PROPERTY_LOCAL_WATCH = {
  N: 'No',
  Y: 'Yes',
};

// STEP 3

// marital status
export const MARITAL_STATUS = {
  M: 'Married',
  S: 'Single',
  D: 'Divorced',
  W: 'Widowed',
  C: 'Co-habiting/Partner',
  V: 'Civil Partnership',
  T: 'Separated',
};
export const INSURED_MARITAL_STATUS_FAVORITES = ['M', 'S', 'C'];

// employment status
export const INSURED_EMPLOYMENT_STATUS_EDUCATION = 'F';
export const INSURED_EMPLOYMENT_STATUS = {
  E: 'Employed',
  F: 'Full-Time Education',
  S: 'Self Employed',
  R: 'Retired',
  U: 'Unemployed',
  D: 'Director',
  P: 'Proprietor or Partner',
  H: 'Houseperson',
  I: 'Independent Means',
  N: 'Not Employed Due to Disability',
  G: 'Government',
  C: 'Club or Association',
};

export const EMPLOYMENT_STATUS_FAVORITES = ['E', 'S', 'F', 'R'];
export const INSURED_EMPLOYMENT_STATUS_FAVORITES = ['E', 'S', 'F'];
export const INSURED_EMPLOYMENT_STATUS_BUSINESS = ['E', 'F', 'S', 'D', 'P', 'G', 'C'];

// additional insured relationship proposer
export const INSURED_ADDITIONAL_RELATIONSHIP_PROPOSER = {
  H: 'Husband',
  W: 'Wife',
  C: 'Co-habiting',
  P: 'Civil Partner',
  O: 'Other Family Member',
  U: 'Unrelated',
};
export const INSURED_ADDITIONAL_RELATIONSHIP_PROPOSER_FAVORITES = ['H', 'W', 'C', 'P'];

// cover occupant convictions
export const COVER_OCCUPANTS_CONVICTIONS = {
  N: 'None',
  M: 'Motoring Offences Only',
  O: 'Other Offences',
};

// property cover payment type
export const COVER_PROPERTY_PAYMENT_TYPE = {
  A: 'Annually',
  M: 'Monthly Instalments',
};

// building no claims bonus
export const COVER_BUILDING_NO_CLAIMS_BONUS = {
  0: '0',
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9+',
};

// contents no claims bonus
export const COVER_CONTENTS_NO_CLAIMS_BONUS = {
  0: '0',
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9+',
};

// build voluntary excess
export const COVER_BUILD_VOLUNTARY_EXCESS = {
  0: 'None',
  50: '£ 50',
  100: '£ 100',
  150: '£ 150',
  200: '£ 200',
  250: '£ 250',
  300: '£ 300',
  350: '£ 350',
  400: '£ 400',
  450: '£ 450',
  500: '£ 500',
};

// property claim type
export const CLAIM_PROPERTY_CLAIM_TYPE = {
  B: 'Buildings',
  C: 'Contents',
};

// claim cause
export const CLAIM_CAUSE = {
  AA: 'Alternative Accommodation',
  AD: 'Accidental Damage',
  AE: 'Additional Expenses',
  AL: 'Accidental Loss',
  BB: 'Burst Boiler',
  BP: 'Burst Pipe',
  BT: 'Burst Tank',
  DF: 'Deep Freeze Contents',
  DJ: 'Damage to Jewellery',
  DS: 'Damage to Spectacles/Contact Lenses',
  EQ: 'Earthquake',
  EX: 'Explosion',
  FI: 'Fire Damage',
  FL: 'Flood Damage',
  FR: 'Frost Damage',
  FY: 'Flight Delay',
  HC: 'Holiday Cancellation',
  HJ: 'Hi-Jack',
  IM: 'Impact Damage',
  LE: 'Legal Expenses Fee',
  LI: 'Liability',
  LJ: 'Loss of Jewellery',
  LR: 'Loss of Rent',
  LS: 'Loss of Spectacles/Contact Lenses',
  LT: 'Lightning Damage',
  MD: 'Malicious Damage',
  ME: 'Medical Expenses',
  PA: 'Personal Accident',
  PC: 'Pedal Cycle Claims (Ex Theft)',
  ST: 'Storm Damage',
  SU: 'Subsidence',
  TD: 'Theft Damage',
  TE: 'Terrorism',
  TH: 'Theft',
  TP: 'Theft of Pedal Cycle',
  TR: 'Transit Damage',
  TV: 'Theft From Vehicle',
  VB: 'Vehicle Breakdown',
  VF: 'Veterinary Fees',
  WD: 'Water Damage',
};

// claim status
export const CLAIM_STATUS = {
  OT: 'Outstanding',
  ST: 'Settled',
  NC: 'I\'ve had a loss but did not make a claim',
};

// RESULTS
export const COVER_VOLUNTARY_EXCESS = {
  0: 'None',
  50: '£ 50',
  100: '£ 100',
  150: '£ 150',
  200: '£ 200',
  250: '£ 250',
  300: '£ 300',
  350: '£ 350',
  400: '£ 400',
  450: '£ 450',
  500: '£ 500',
  550: '£ 550',
  600: '£ 600',
  650: '£ 650',
  700: '£ 700',
  750: '£ 750',
  800: '£ 800',
  850: '£ 850',
  900: '£ 900',
  950: '£ 950',
  1000: '£ 1000',
};

export const OPTIONAL_EXTRAS_OPTIONS = [{
  value: 'legalAssistance',
  trackerValue: 'legalAssistance',
  label: 'Legal Assistance',
  viewIndex: 1, // viewIndex used for required display order in results options
},
{
  value: 'building/damage',
  trackerValue: 'buildingsDamage',
  label: 'Buildings Damage',
},
{
  value: 'contents/damage',
  trackerValue: 'contentsDamage',
  label: 'Contents Damage',
},
{
  value: 'homeEmergencyV2',
  trackerValue: 'homeEmergency',
  label: 'Home Emergency',
  viewIndex: 2,
}];

export const OPTIONAL_EXTRAS_TRACKER_OPTIONS = createTrackerOptions(OPTIONAL_EXTRAS_OPTIONS);
